import { Component, Input, OnInit } from '@angular/core';
import { ILink } from '../../links/link.interface';
import { Router } from '@angular/router';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-navigation-mobile-link',
  templateUrl: 'link.component.html',
  styleUrls: ['link.component.css']
})
export class LinkComponent implements OnInit {
  @Input() navigationLink!: ILink;
  @Input() unlockCase!: boolean;
  @Input() isExternalLink!: boolean;
  @Input() forceReload!: boolean;
  @Input() opened!: boolean;
  
  link!: ILink;
  shouldUnlockCase!: boolean;
  isExternal!: boolean;
  isSimpleLocal!: boolean;
  isNamedRoute!: boolean;
  isOpened!: boolean;
  
    constructor(protected formService: FormService, private router: Router) {}

  ngOnInit(): void {
    this.link = this.navigationLink;
    this.isExternal = this.isExternalLink && !this.forceReload;
    this.isSimpleLocal = !this.isExternalLink && !this.forceReload;
    this.isNamedRoute = !this.isExternalLink && this.forceReload;
    this.isOpened = this.opened === undefined ? true : this.opened;
  }

  clickAction() {
    if(this.shouldUnlockCase) {
      this.formService.unlockCase();
    }

    if(this.isExternal) {
      window.open(this.link.externalUrl, "_blank");
    } else if(this.isSimpleLocal) {
      this.router.navigate([this.route]);
    } else {
      // Forces reload of the data.
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([this.route]);
      });
    }
  }
  
  get route() {
    return this.link.route;
  }

  get text() {
    return this.link.text;
  }

  get iconName() {
    return this.link.iconName;
  }
}
